export let hres75uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codobf',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codunit',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'amtreq',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '80',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'amtwidrw',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '90',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES75UC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }
  ]
  let tab2TableColumns = [
    {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES75UC3',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 150px;',
      dataType: 'date'
    }, {
      key: 'numvcher',
      name: '',
      labelCodapp: 'HRES75UC3',
      labelIndex: '50',
      style: 'min-width: 150px;'
    }, {
      key: 'amtwidrw',
      name: '',
      labelCodapp: 'HRES75UC3',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codunit',
      name: '',
      labelCodapp: 'HRES75UC3',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desnote',
      name: '',
      labelCodapp: 'HRES75UC3',
      labelIndex: '80',
      style: 'min-width: 300px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    },
    th: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres75u.js